import React, { useState } from "react";
import { FF, T } from "../lib/constants";

// Lijst losse labels (tags, accenten) bewerken: typen + Enter of de +-knop.
// Tik op een label om het aan te passen (Enter of ergens anders tikken = opslaan,
// Esc = annuleren, leegmaken = verwijderen). Lange labels lopen door over meerdere regels.
export default function ChipEditor({ items, onChange, placeholder, color }) {
  var [val, setVal] = useState("");
  var [edit, setEdit] = useState(null); // { i, v }
  var c = color || "#4A4740";
  function add() { var v = val.trim(); if (!v) return; if (items.indexOf(v) < 0) onChange(items.concat([v])); setVal(""); }
  function remove(i) { var n = items.slice(); n.splice(i, 1); onChange(n); }
  function commit() {
    if (!edit) return;
    var v = edit.v.replace(/\s+/g, " ").trim(), n = items.slice();
    if (!v) n.splice(edit.i, 1);
    else if (v !== n[edit.i]) n[edit.i] = v;
    setEdit(null);
    if (JSON.stringify(n) !== JSON.stringify(items)) onChange(n);
  }
  var chip = { fontSize: 12, fontWeight: 700, borderRadius: 12, background: c + "14", color: c, border: "1px solid " + c + "40", maxWidth: "100%", boxSizing: "border-box", fontFamily: FF };
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 6, alignItems: "center", border: "1px solid " + T.line, borderRadius: 10, padding: "5px 6px 5px 8px", background: "#fff", minHeight: 40, boxSizing: "border-box", fontFamily: FF, minWidth: 0 }}>
      {items.map(function (t, i) {
        if (edit && edit.i === i) return (
          <textarea key={i} autoFocus value={edit.v} rows={1} aria-label="Label aanpassen"
            onChange={function (e) { setEdit({ i: i, v: e.target.value }); }} onBlur={commit}
            onFocus={function (e) { var el = e.target; el.style.height = "auto"; el.style.height = el.scrollHeight + "px"; el.setSelectionRange(el.value.length, el.value.length); }}
            onInput={function (e) { var el = e.target; el.style.height = "auto"; el.style.height = el.scrollHeight + "px"; }}
            onKeyDown={function (e) { if (e.key === "Enter") { e.preventDefault(); commit(); } else if (e.key === "Escape") { e.preventDefault(); setEdit(null); } }}
            style={Object.assign({}, chip, { flex: "1 1 160px", padding: "3px 10px", lineHeight: 1.35, outline: "2px solid " + c + "55", resize: "none", overflow: "hidden", background: "#fff", display: "block" })} />
        );
        return (
          <span key={i} style={Object.assign({}, chip, { padding: "2px 2px 2px 10px", display: "inline-flex", alignItems: "flex-start", gap: 2 })}>
            <button type="button" onClick={function () { commit(); setEdit({ i: i, v: t }); }} title="Tik om aan te passen" aria-label={"Pas aan: " + t}
              style={{ background: "none", border: "none", padding: "2px 0", margin: 0, cursor: "text", color: "inherit", font: "inherit", textAlign: "left", lineHeight: 1.35, whiteSpace: "normal", overflowWrap: "anywhere", minWidth: 0 }}>
              {t}
            </button>
            <button type="button" onClick={function () { remove(i); }} aria-label={"Verwijder " + t}
              style={{ background: "none", border: "none", cursor: "pointer", color: c, padding: 0, width: 22, height: 22, display: "inline-flex", alignItems: "center", justifyContent: "center", flex: "none" }}>
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" /></svg>
            </button>
          </span>
        );
      })}
      <input value={val} onChange={function (e) { setVal(e.target.value); }} onBlur={add}
        onKeyDown={function (e) { if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(); } else if (e.key === "Backspace" && !val && items.length) { remove(items.length - 1); } }}
        placeholder={placeholder || "Toevoegen..."} aria-label={placeholder || "Toevoegen"}
        style={{ flex: "1 1 120px", minWidth: 100, border: "none", padding: "4px 2px", fontSize: 13, outline: "none", fontFamily: FF, background: "transparent", color: T.ink }} />
    </div>
  );
}
